"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactWindow = require("react-window");

var _reactWindowInfiniteLoader = _interopRequireDefault(require("react-window-infinite-loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/prop-types */

/* eslint-disable react/destructuring-assignment */
var LOADING = 1;
var LOADED = 2;
var itemStatusMap = {};

var isItemLoaded = function isItemLoaded(index) {
  return !!itemStatusMap[index];
};

var loadMoreItems = function loadMoreItems(startIndex, stopIndex) {
  for (var index = startIndex; index <= stopIndex; index += 1) {
    itemStatusMap[index] = LOADING;
  }

  return new Promise(function (resolve) {
    return setTimeout(function () {
      for (var _index = startIndex; _index <= stopIndex; _index += 1) {
        itemStatusMap[_index] = LOADED;
      }

      resolve();
    }, 0);
  });
};

var _default = function _default(props) {
  // eslint-disable-next-line react/prop-types
  var height = props.height,
      items = props.items,
      itemSize = props.itemSize;
  var actualHeight = height || 150;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactWindowInfiniteLoader["default"], {
    isItemLoaded: isItemLoaded,
    itemCount: props.items.length,
    loadMoreItems: loadMoreItems
  }, function (_ref) {
    var onItemsRendered = _ref.onItemsRendered,
        ref = _ref.ref;
    return /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
      className: "List",
      height: actualHeight,
      itemCount: items.length,
      itemSize: itemSize || 30,
      onItemsRendered: onItemsRendered,
      ref: ref,
      width: "100%"
    }, function (_props) {
      var index = _props.index,
          style = _props.style;
      var isLoading = true;

      if (itemStatusMap[index] === LOADED) {
        isLoading = false;
      }

      return props.renderRow(index, style, isLoading);
    });
  }));
};

exports["default"] = _default;